import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.667 10.667c.294 0 .533.238.533.533v1.6c0 .59.475 1.067 1.063 1.067h7.472c.588 0 1.065-.477 1.065-1.067v-1.6a.533.533 0 1 1 1.067 0v1.6a2.13 2.13 0 0 1-2.132 2.133H4.263a2.13 2.13 0 0 1-2.13-2.133v-1.6c0-.295.24-.533.534-.533M7.66 8.074a.48.48 0 0 0 .68 0l3.2-3.2a.48.48 0 1 0-.68-.68L8.48 6.575V-.799a.48.48 0 1 0-.96 0v7.373l-2.38-2.38a.48.48 0 1 0-.68.678l3.2 3.2Z",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgExport);
export default Memo;
